import { getTranslation } from '@owc/aem-translations-util';
import type { AemData } from '../aemData';
import { getLocale } from '../../utils/locale';
import { useI18n } from './index';
import { i18nProjectId } from '../../lib/configuration';
import type { I18nCtx } from './types';
import { sendServiceError } from '../../services/Error';

/**
 * Loads the i18n messages from Phrase using AEM environment and sets them in the i18n plugin.
 * Requires i18n plugin to be installed.
 */
export async function provideI18nFromAEM(aemData: AemData) {
  const i18n = useI18n();

  await loadI18nFromAEM(i18n, aemData);
}

export async function loadI18nFromAEM(i18n: I18nCtx, aemData: AemData) {
  i18n.setDebug(aemData.isAemEditMode);
  try {
    i18n.setMessages(
      await getTranslation(getLocale(aemData), i18nProjectId, 'i18next', {
        include_empty_translations: true,
        fallback_locale_id: 'en',
      }),
    );
  } catch (error) {
    sendServiceError(aemData, error instanceof Error ? error : new Error(error as string), 'i18n');
  }
}
